import { z } from 'zod';
export const orgRecipientRoutes = {
    read: {
        method: 'GET',
        path: '/organization/:organizationId/recipients/:orgRecipientId',
        output: {},
    },
    list: {
        method: 'GET',
        path: '/organization/:organizationId/recipients',
        output: {},
    },
    create: {
        method: 'POST',
        path: '/organization/:organizationId/recipient',
        input: z.object({
            firstName: z.string(),
            lastName: z.string().nullable(),
            email: z.string().email(),
            phoneNumber: z.string().optional().nullable(),
            locale: z.string(),
            timezone: z.string(),
        }),
        output: {},
    },
    update: {
        method: 'POST',
        path: '/organization/:organizationId/recipient/:orgRecipientId',
        input: z.object({
            firstName: z.string(),
            lastName: z.string().nullable(),
            phoneNumber: z.string().optional().nullable(),
        }),
        output: {},
    },
    cadenceUpdate: {
        method: 'POST',
        path: '/organization/:organizationId/cadence/:cadenceId',
        input: z.object({
            startDate: z.string().optional(),
            utcHour: z.number().optional(),
            minute: z.number().optional(),
            period: z.string().optional().nullable(),
            value: z.number().optional().nullable(),
            offset: z.number().optional().nullable(),
            avoidWeekend: z.boolean().optional().nullable(),
            enabled: z.boolean().optional().nullable(),
        }),
        output: {},
    },
    delete: {
        method: 'DELETE',
        path: '/organization/:organizationId/recipient/:orgRecipientId',
        output: {},
    },
    getUpcomingReminders: {
        method: 'POST',
        path: '/organization/:organizationId/recipient/:orgRecipientId/get-upcoming-reminder-times',
        input: z.object({
            cadence: z.object({
                startDate: z.string(),
                utcHour: z.number(),
                minute: z.number(),
                avoidWeekend: z.boolean(),
                enabled: z.boolean(),
                offset: z.number(),
                period: z.union([
                    z.literal('DEADLINE'),
                    z.literal('DAILY'),
                    z.literal('WEEKLY'),
                    z.literal('MONTHLY'),
                    z.literal('YEARLY'),
                ]),
                value: z.number(),
            }),
        }),
        output: {},
    },
};
//# sourceMappingURL=org-recipient-routes.js.map